import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  medias: {
    data: [],
    meta: {
      total: 0,
    },
  },

  mainMedias: [],
};

// TODO: fetch all the medias
export const fetchMedias = createAsyncThunk(
  "fetchMedias/medias",
  async ({ enqueueSnackbar, search }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`media`, {
        params: {
          ...(search !== "" && {
            search,
          }),
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create media
export const createMedia = createAsyncThunk(
  "createMedia/medias",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`media`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update media
export const updateMedia = createAsyncThunk(
  "updateMedia/medias",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`media/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete media
export const deleteMedia = createAsyncThunk(
  "deleteMedia/medias",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`media/remove?link=${id}`,);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const mediaslice = createSlice({
  name: "media",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get media
    builder.addCase(fetchMedias.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchMedias.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.medias.data = action.payload.data;
    });

    builder.addCase(fetchMedias.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create media
    builder.addCase(createMedia.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createMedia.fulfilled, (state, action) => {
      state.isLoading = false;
      state.medias.data = [action.payload.data, ...state.medias.data];
      state.medias.meta.total = state.medias.meta.total + 1;
      action.payload.enqueueSnackbar("Media is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createMedia.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error, {
        variant: "error",
      });
    });

    // TODO: update media
    builder.addCase(updateMedia.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateMedia.fulfilled, (state, action) => {
      state.isLoading = false;
      state.medias.data.data = state.medias.data.data.map((media) => {
        if (media.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return media;
        }
      });
      action.payload.enqueueSnackbar("Media is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateMedia.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete media
    builder.addCase(deleteMedia.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteMedia.fulfilled, (state, action) => {
      state.isLoading = false;
      state.medias.data = state.medias.data.filter(
        (media) => media.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Media is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteMedia.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default mediaslice.reducer;

export const { resetLoadings } = mediaslice.actions;
